import { Search } from "lucide-react";
import type { Organization } from "./types";

interface Props {
  q: string;
  organizationId: string;
  organizations: Organization[];
  showOrgFilter: boolean;
  onQChange: (q: string) => void;
  onOrganizationChange: (orgId: string) => void;
}

export default function AdAccountFilters({
  q, organizationId, organizations, showOrgFilter,
  onQChange, onOrganizationChange,
}: Props) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <input
          value={q}
          onChange={(e) => onQChange(e.target.value)}
          placeholder="搜索账户名、act_id、公司"
          className="w-full rounded-md border border-border bg-background pl-9 pr-3 py-1.5 text-sm"
        />
      </div>
      {showOrgFilter && (
        <select
          value={organizationId}
          onChange={(e) => onOrganizationChange(e.target.value)}
          className="rounded-md border border-border bg-background px-3 py-1.5 text-sm min-w-[140px]"
        >
          <option value="">所有公司</option>
          {organizations.map((o) => (
            <option key={o.id} value={o.id}>{o.name}</option>
          ))}
        </select>
      )}
    </div>
  );
}
